import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkboxCheck",
  "use": "checkboxCheck-usage",
  "viewBox": "0 0 54 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 54 44\" id=\"checkboxCheck\">\n<path d=\"M47.5,0.7c1.6,0,3.2,0.6,4.4,1.9c2.4,2.5,2.4,6.6,0,9.1L23.1,41.4c-2.5,2.5-6.4,2.5-8.9,0L2.2,29c-2.4-2.5-2.4-6.6,0-9.1\n\ts6.4-2.5,8.8,0l7.7,7.9L43.1,2.6C44.3,1.3,45.9,0.7,47.5,0.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol